import FlightsForm from './FlightsForm';

export default FlightsForm;
